<template>
	<div>
		<egranty-section-divider
			text="Grupy docelowe"
			icon="people"
		></egranty-section-divider>

		<br style="margin-top: 20px">
		<v-layout row>
			<v-flex xs5>
				<v-expand-transition aria-label="label for group">
					<v-select
						v-if="!readonly || data.selected.length"
						style="padding-left: 20px; padding-right: 20px; max-width: 500px"
						:disabled="readonly"
						v-model="data.selected"
						:items="options"
						item-text="name"
						item-value="id"
						multiple
						label="Grupy docelowe"
						aria-label="beneficiaries"
						for="agency-choose-beneficiaries-point-groups-target"
						id="agency-choose-beneficiaries-point-groups-target"
						@input="sync"
					></v-select>
				</v-expand-transition>
			</v-flex>
			<v-flex v-if="!readonly" xs2>
				<egranty-switch
					aria-label="another beneficiary enabled"
					title='Inna grupa docelowa'
					v-model="data.otherBeneficiaryEnabled"
					@input="hasOtherBeneficiaryChanged"
				></egranty-switch>
			</v-flex>
			<v-flex xs4>
				<v-expand-transition>
					<egranty-text-input-field
						class="other-group-target-card"
						style="margin-left: 20px"
						:disabled="readonly"
						v-show="data.otherBeneficiaryEnabled"
						label="Nazwa innej grupy docelowej"
						for="agency-choose-beneficiaries-name-other-groups-target"
						id="agency-choose-beneficiaries-name-other-groups-target"
						v-model="data.otherBeneficiary"
						@input="sync"
						textarea
						:max-length="255"
					>
					</egranty-text-input-field>
				</v-expand-transition>
			</v-flex>
		</v-layout>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
	import EgrantySwitch from "../../../../genericComponents/EgrantySwitch";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import {AgencyBeneficiary} from "../../../../api/generated/AgencyBeneficiary";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {
		name: "AgencyChooseBeneficiaries",
		components: {EgrantyValidationError, EgrantySectionDivider, EgrantyTextInputField, EgrantySwitch},
		methods: {
			getContestId() {
				return this.$route.params.id;
			},

			sync() {
				this.$emit("input", this.data);
				this.error = "";
			},

			hasOtherBeneficiaryChanged(newHasOtherBeneficiary) {
				if (newHasOtherBeneficiary) {
					this.data.otherBeneficiary = null;
				}
				this.sync();
			},

			validate() {
				this.error = "";
				if (!this.data.selected.length && !this.data.otherBeneficiaryEnabled) {
					this.error = "Prosze wybrać co najmniej jedną grupę docelową";
				}
				if (this.data.otherBeneficiaryEnabled && !this.data.otherBeneficiary) {
					this.error = "Proszę podać nazwę innej grupy docelowej";
				}
				return this.error === "";
			},
		},

		mounted() {
			AgencyBeneficiary.getAllBeneficiaries(
				this,
				this.getContestId(),
				response => {
					this.options = response;
				},
			);

		},

		data() {
			return {
				error: "",
				data: {
					selected: [],
					otherBeneficiary: "",
					otherBeneficiaryEnabled: false,
				},
				options: [],

			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.data.otherBeneficiary = val.otherBeneficiary;
					this.data.otherBeneficiaryEnabled = val.otherBeneficiaryEnabled;
					this.data.selected = val.selected;
				},
			},
		},

		props: {
			readonly: {default: false},
			value: {},
		},
	};
</script>

<style>
@media print {
	.other-group-target-card {
		margin: 0 10px 10px;
	}
	.other-group-target-card .div-for-print {
		border: 1px solid grey;
		color: rgba(0,0,0,0.87);
	}
	.other-group-target-card p {
		margin-bottom: 8px;
	}
	.agency-choose-actions {
		border: 1px solid grey;
		margin-bottom: 10px;
	}
	.agency-actions-costs .blue.white--text {
		border: 1px solid grey !important;
	}
	.agency-actions-costs i {
		display: none;
	}
}
</style>
